// Restangular service that returns the full response
export default function RestangularStatus(Restangular) {
  'ngInject';

  return Restangular.withConfig((RestangularConfigurer) => {
    RestangularConfigurer.setBaseUrl(Restangular.configuration.baseUrl);
    RestangularConfigurer.setFullResponse(true);
  });
}
